import React from 'react';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { refundAmazonOrder } from '../../../../../actions/tools/DecisionTree/AmazonActions';
import { useDispatch } from 'react-redux';

const DTCancelAmazonOrderAndSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(refundAmazonOrder());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to refund the items for this order and copy the response to the text box'}
      customErrorMessage={'There was a problem refunding the order. Please try again later.'}
    />
  );
};

export default withConfirmation(DTCancelAmazonOrderAndSendMacroNode);
